import { Building2, Globe2, Landmark, WalletCards } from "lucide-react";

import { paymentMethodDefinition } from "./registry";

export function PaymentMethodIcon({ methodId }: { methodId: string }) {
  const definition = paymentMethodDefinition(
    methodId === "fiat" ? "bank" : methodId,
  );

  if (definition?.iconUrl) {
    return (
      <span
        aria-hidden
        className="cashier-payment-icon"
        data-method={definition.id}
        data-treatment={definition.iconTreatment}
      >
        <img alt="" src={definition.iconUrl} />
      </span>
    );
  }

  const glyph =
    definition?.id === "bank" ? (
      <Landmark aria-hidden />
    ) : definition?.id === "cashapp" ? (
      <span aria-hidden className="cashier-payment-icon__cashapp">
        $
      </span>
    ) : definition?.id === "venmo" ? (
      <span aria-hidden className="cashier-payment-icon__venmo">
        V
      </span>
    ) : definition?.id === "wire" ? (
      <Building2 aria-hidden />
    ) : definition?.id === "gateway" ? (
      <Globe2 aria-hidden />
    ) : definition?.id === "interac" ? (
      <span aria-hidden className="cashier-payment-icon__interac">
        i
      </span>
    ) : (
      <WalletCards aria-hidden />
    );

  return (
    <span
      aria-hidden
      className="cashier-payment-icon"
      data-method={definition?.id ?? "other"}
      data-treatment="text"
    >
      {glyph}
    </span>
  );
}
